/**
 * @generated SignedSource<<2ff0e1e668cb4d3efdaa1b3ff2f5405d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUpdateRecentSearchResultEntryFromItemSearch_itemSearch$data = {
  readonly appliedFilters: ReadonlyArray<{
    readonly name: string | null;
    readonly values: ReadonlyArray<{
      readonly urlLabel: string | null;
    } | null> | null;
  } | null> | null;
  readonly searchCorrections: {
    readonly classificationSearchTerm: string | null;
    readonly originalSearchTerm: string | null;
    readonly semanticSearchTerm: string | null;
  } | null;
  readonly searchTerm: string | null;
  readonly totalResults: number | null;
  readonly " $fragmentType": "useUpdateRecentSearchResultEntryFromItemSearch_itemSearch";
};
export type useUpdateRecentSearchResultEntryFromItemSearch_itemSearch$key = {
  readonly " $data"?: useUpdateRecentSearchResultEntryFromItemSearch_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUpdateRecentSearchResultEntryFromItemSearch_itemSearch">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useUpdateRecentSearchResultEntryFromItemSearch_itemSearch"
};

(node as any).hash = "29ba66fb517c838aa44689635fd891a1";

export default node;
